exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.embedded-designer[data-v-9540e370] {\r\n  height: 100%;\r\n  width: 100%;\n}\r\n", ""]);

// exports
